module.exports = __webpack_public_path__ + "static/media/MHRP39N0008.0fc4a26d.svg";